<template>
  <div>
  </div>
</template>

<script>
/**
 * This file is part of the GMS package.
 * 
 * @version 1.1
 */

import { eventBus } from '@/lib/gms/event_bus.js'

/**
 *  Globální EventBus.
 */
export default {
  methods: {
    onError: function (error) {
      console.log('EventBus.vue#onError', error)

      /*this.$bvToast.toast(error.message, {
        autoHideDelay: 3000,
        appendToast: false,
        solid: true,
        title: this.$t('Error'),
        toaster: 'b-toaster-top-center',
        variant: "danger"
      })*/
    },

    onNotice: function (error) {
      //console.log('EventBus.vue#onNotice', error)

      this.$bvToast.toast(error.message, {
        autoHideDelay: 1000,
        appendToast: false,
        solid: true,
        title: this.$t('Success'),
        toaster: 'b-toaster-top-center',
        variant: "success"
      })
    },

    onUrgentError: function (error) {
      console.error('EventBus.vue#onUrgentError', error)
              //this.$router.push('/error-500')
      this.$router.push('/error')
    },

    onWarning: function (error) {
      console.log('EventBus.vue#onWarning', error)

      this.$bvToast.toast(error.message, {
        autoHideDelay: 2000,
        appendToast: false,
        solid: true,
        title: this.$t('Warning'),
        toaster: 'b-toaster-top-center',
        variant: "warning"
      })
    }
  },

  mixins: [ ],

  mounted( ) {
    // Událost "ERROR"
    eventBus.addEventListener(eventBus.eventTypes.ERROR, parameters => {
      this.onError(parameters)
    })

    // Událost "NOTICE"
    eventBus.addEventListener(eventBus.eventTypes.NOTICE, parameters => {
      this.onNotice(parameters)
    })

    // Událost "URGENT_ERROR"
    eventBus.addEventListener(eventBus.eventTypes.URGENT_ERROR, parameters => {
      this.onUrgentError(parameters)
    })

    // Událost "WARNING"
    eventBus.addEventListener(eventBus.eventTypes.WARNING, parameters => {
      this.onWarning(parameters)
    })
  }
}
</script>